import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_LEFT: GlameraIconDefinition = {
  name: 'arrow-left',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-left-nudge">
      <path d="m12 19-7-7 7-7"></path>
      <path d="M19 12H5"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-left-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-left.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowLeftIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_LEFT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
